// extracted by css-extract-rspack-plugin
export default {"DateStringEditor":"src-wab-client-components-sidebar-tabs-ComponentProps-DateStringEditor-module__DateStringEditor-tFP65V","dateStringEditor":"src-wab-client-components-sidebar-tabs-ComponentProps-DateStringEditor-module__DateStringEditor-tFP65V"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"DateStringEditor\":\"src-wab-client-components-sidebar-tabs-ComponentProps-DateStringEditor-module__DateStringEditor-tFP65V\",\"dateStringEditor\":\"src-wab-client-components-sidebar-tabs-ComponentProps-DateStringEditor-module__DateStringEditor-tFP65V\"}";
        // 1793541994263
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  